import '@vfde-brix/image-slider/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import { createImageSliderComponent } from '@vfde-brix/image-slider';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-image-slider', createImageSliderComponent, NO_PATTERN_BUSINESS_LOGIC);
